import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { queryKeys } from "./queryKeys";

const uploadFile = async (file: any) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await axios.post("/utils/upload-s3", formData);
  return data;
};

export const useFileInputUploader = (
  onSuccess?: (data: any) => void,
  onError?: (error: any) => void
) =>
  useMutation({
    mutationFn: uploadFile,
    onSuccess,
    onError,
  });

const readFile = async (fileKey: string) => {
  const { data } = await axios.get(`/utils/s3-signed-url?key=${fileKey}`);
  return data;
};

export const useReadFile = (justFetch = false) =>
  useMutation({
    mutationFn: readFile,
    onSuccess: (res) => {
      const decodedUrl = decodeURIComponent(res);
      if (justFetch) return decodedUrl;
      return window.open(decodedUrl);
    },
  });

/** A signed URL to show a stored file in place. They last 5 minutes, so one is reused for 4. */
export const useFileUrl = (fileKey?: string | null) =>
  useQuery({
    queryKey: [queryKeys.FILE_URL, fileKey],
    queryFn: async () => decodeURIComponent(await readFile(fileKey as string)),
    enabled: !!fileKey,
    staleTime: 4 * 60 * 1000,
  });
